import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getSelectActivityTariff = (state: StateScheme) => {
    return state.selectTariff.selectedActivityTariff
}
